
import React from 'react';
import { KnowledgeDocument } from './types';
import { SearchBar } from './SearchBar';
import { DocumentsTable } from './DocumentsTable';

interface DocumentsTabProps {
  filteredDocuments: KnowledgeDocument[];
  loading: boolean;
  searchQuery: string;
  searchLoading: boolean;
  currentPage: number;
  pageSize: number;
  totalCount: number;
  topicFilter: string;
  onSearchChange: (query: string) => void;
  onTopicFilterChange: (topic: string) => void;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  onEditDocument: (document: KnowledgeDocument) => void;
  onDeleteDocument: (id: string) => void;
}

export const DocumentsTab: React.FC<DocumentsTabProps> = ({
  filteredDocuments,
  loading,
  searchQuery,
  searchLoading,
  currentPage,
  pageSize,
  totalCount,
  topicFilter,
  onSearchChange,
  onTopicFilterChange,
  onPageChange,
  onPageSizeChange,
  onEditDocument,
  onDeleteDocument
}) => {
  return (
    <div className="space-y-4">
      <SearchBar
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        searchLoading={searchLoading}
        topicFilter={topicFilter}
        onTopicFilterChange={onTopicFilterChange}
      />

      <DocumentsTable
        documents={filteredDocuments}
        loading={loading}
        currentPage={currentPage}
        pageSize={pageSize}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        onEditDocument={onEditDocument}
        onDeleteDocument={onDeleteDocument}
      />
    </div>
  );
};
